import {
	IInitialFormData,
	TEditVideoCategoryVisibleForm,
	TTypeOfEditVideoCategoryModalWindow,
} from './editVideoCategoryContext';
import { IItemForGetShortInfo, TLanguageIDs, IUpdateVideoCategory, IVideoCategoryTranslation } from 'types';

export enum EditVideoCategoryActionTypes {
	REFETCH_DATA = 'REFETCH_DATA',
	SET_INITIAL_FORM_DATA = 'SET_INITIAL_FORM_DATA',
	SET_ALL_DATA = 'SET_ALL_DATA',
	CHANGE_VISIBLE_FORM = 'CHANGE_VISIBLE_FORM',
	CHANGE_NAME = 'CHANGE_NAME',
	SET_FETCHED_LANGUAGES = 'SET_FETCHED_LANGUAGES',
	SET_IDs_LANGUAGES = 'SET_IDs_LANGUAGES',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SET_TRANSLATION_TAB = 'SET_TRANSLATION_TAB',
	SET_TRANSLATION_FIELDS = 'SET_TRANSLATION_FIELDS',
	CHANGE_TRANSLATION = 'CHANGE_TRANSLATION',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface IRefetchData {
	type: EditVideoCategoryActionTypes.REFETCH_DATA;
	payload: {
		needRefetch: boolean;
	};
}

interface ISetInitialFormData {
	type: EditVideoCategoryActionTypes.SET_INITIAL_FORM_DATA;
	payload: {
		initialFormData: IInitialFormData;
	};
}

interface ISetAllData {
	type: EditVideoCategoryActionTypes.SET_ALL_DATA;
	payload: {
		categoryID: string;
		name: string;
		IDsSelectedLanguages: TLanguageIDs[];
		translations: IVideoCategoryTranslation[];
	};
}

interface IChangeVisibleForm {
	type: EditVideoCategoryActionTypes.CHANGE_VISIBLE_FORM;
	payload: {
		visibleForm: TEditVideoCategoryVisibleForm;
	};
}

interface IChangeName {
	type: EditVideoCategoryActionTypes.CHANGE_NAME;
	payload: {
		name: string;
	};
}

interface ISetFetchedLanguages {
	type: EditVideoCategoryActionTypes.SET_FETCHED_LANGUAGES;
	payload: {
		languages: IItemForGetShortInfo[];
	};
}

interface ISetIDsLanguages {
	type: EditVideoCategoryActionTypes.SET_IDs_LANGUAGES;
	payload: {
		IDsLanguages: TLanguageIDs[];
	};
}

interface ISetDataForSubmit {
	type: EditVideoCategoryActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		data: IUpdateVideoCategory | null;
	};
}

interface IChangeTypeOfModalWindow {
	type: EditVideoCategoryActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfEditVideoCategoryModalWindow;
	};
}

interface ISetTranslationTab {
	type: EditVideoCategoryActionTypes.SET_TRANSLATION_TAB;
	payload: {
		translationTab: TLanguageIDs | null;
	};
}

interface ISetTranslationFields {
	type: EditVideoCategoryActionTypes.SET_TRANSLATION_FIELDS;
	payload: {
		updatedTranslations: IVideoCategoryTranslation[];
	};
}

interface IChangeTranslation {
	type: EditVideoCategoryActionTypes.CHANGE_TRANSLATION;
	payload: {
		updatedTranslations: IVideoCategoryTranslation[];
	};
}

interface IResetSelectedControls {
	type: EditVideoCategoryActionTypes.RESET_FIELDS;
}

export type TEditVideoCategoryAction =
	| IRefetchData
	| ISetInitialFormData
	| ISetAllData
	| IChangeVisibleForm
	| IChangeName
	| ISetFetchedLanguages
	| ISetIDsLanguages
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow
	| ISetTranslationTab
	| ISetTranslationFields
	| IChangeTranslation
	| IResetSelectedControls;
